import { About, Footer, Header, Skills, Testimonial, Work } from './container'
import { Navbar } from './components'
import './App.scss'
import Offer from './container/offer/Offer';

import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import HomeIcon from "@material-ui/icons/Home"
import Contact from "@material-ui/icons/ContactPhone"
import WorkIcon from "@material-ui/icons/Work"
import Docs from "@material-ui/icons/Drafts"
import Profile from "@material-ui/icons/AccountBox"
import { useNavigate } from 'react-router-dom';

const App = () => {



    return (
        <div className='app'>
            <Navbar />
            <Header />
            <About />
            <Work />
            <Skills />
            <Offer />
            <Testimonial />
            <Footer />
        </div>
    );
}

export default App;